<!-- ══ HEADER ══════════════════════════════════════════════════════════ -->
<header class="header">
  <a routerLink="/" class="header-icon">
    <img src="logo.svg" alt="Every Rupee Spent logo" width="36" height="36">
  </a>
  <div class="header-text">
    <p class="header-brand"><a routerLink="/">Every Rupee Spent</a></p>
  </div>

  <button type="button" class="nav-toggle" [class.open]="mobileMenuOpen"
    (click)="toggleMobileMenu()" aria-label="Toggle menu" [attr.aria-expanded]="mobileMenuOpen">
    <span></span><span></span><span></span>
  </button>

  <nav class="main-nav" [class.open]="mobileMenuOpen">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenus()">Home</a>

    <div class="nav-dropdown" [class.open]="calcMenuOpen">
      <button type="button" class="nav-dropdown-trigger" [class.active]="isCalculatorRouteActive()"
        (click)="toggleCalcMenu($event)" [attr.aria-expanded]="calcMenuOpen">
        Calculators
        <svg class="nav-dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div class="nav-dropdown-menu">
        @if (!activeCategory) {
          <div class="nav-category-list">
            @for (category of navCategories; track category.key) {
              <button type="button" class="nav-category-item" [class.active]="isCategoryActive(category.key)"
                (click)="openCategory($event, category.key)">
                <span class="nci-icon"><mat-icon>{{ category.icon }}</mat-icon></span>
                <span class="nci-label">{{ category.label }}</span>
                <svg class="nci-chevron" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>
              </button>
            }
          </div>
        } @else {
          @for (category of navCategories; track category.key) {
            @if (category.key === activeCategory) {
              <div class="nav-submenu">
                <button type="button" class="nav-submenu-back" (click)="backToCategories($event)">
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"/></svg>
                  {{ category.label }}
                </button>
                <div class="nav-dropdown-group">
                  @for (item of category.items; track item.path) {
                    <a [routerLink]="item.path" routerLinkActive="active" (click)="closeMenus()">
                      <mat-icon>{{ item.icon }}</mat-icon> {{ item.label }}
                    </a>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>

    <div class="nav-dropdown" [class.open]="servicesMenuOpen">
      <button type="button" class="nav-dropdown-trigger" [class.active]="isServiceRouteActive()"
        (click)="toggleServicesMenu($event)" [attr.aria-expanded]="servicesMenuOpen">
        Services
        <svg class="nav-dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div class="nav-dropdown-menu">
        <div class="nav-dropdown-group">
          @for (service of navServices; track service.path) {
            <a [routerLink]="service.path" routerLinkActive="active" (click)="closeMenus()">
              <mat-icon>{{ service.icon }}</mat-icon> {{ service.label }}
            </a>
          }
        </div>
      </div>
    </div>

    <a routerLink="/learn" routerLinkActive="active" (click)="closeMenus()" class="nav-icon-link"><mat-icon>menu_book</mat-icon> Learn</a>

    @if (isPremiumLoggedIn()) {
      <div class="nav-dropdown" [class.open]="accountMenuOpen">
        <button type="button" class="nav-dropdown-trigger nav-login-btn" (click)="toggleAccountMenu($event)" [attr.aria-expanded]="accountMenuOpen">
          <mat-icon>account_circle</mat-icon> My Account
          <svg class="nav-dropdown-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        <div class="nav-dropdown-menu nav-account-menu">
          @if (currentUser(); as u) {
            <p class="nav-account-detail">{{ u.displayName ?? u.email }} &middot; {{ u.email }}</p>
          }
          <button type="button" class="btn btn-primary nav-account-logout" (click)="logout()">Log out</button>
        </div>
      </div>
    } @else {
      <a routerLink="/login" class="nav-login-btn" (click)="closeMenus()"><mat-icon>login</mat-icon> Login</a>
    }
  </nav>
</header>

<main>
  <router-outlet></router-outlet>
</main>

<!-- ══ FOOTER ════════════════════════════════════════════════════════════ -->
<footer class="footer">
  <nav class="footer-sitemap" aria-label="All calculators">
    @for (category of navCategories; track category.key) {
      <div class="footer-sitemap-group">
        <span class="footer-sitemap-heading">{{ category.label }}</span>
        @for (item of category.items; track item.path) {
          <a [routerLink]="item.path">{{ item.label }}</a>
        }
      </div>
    }
    <div class="footer-sitemap-group footer-sitemap-group--learn">
      <span class="footer-sitemap-heading">Learn</span>
      <a routerLink="/learn" class="footer-learn-all"><mat-icon>menu_book</mat-icon> All Guides</a>
      @for (article of footerArticles; track article.slug) {
        <a [routerLink]="['/learn', article.slug]" class="footer-learn-link" [title]="article.title">{{ article.title }}</a>
      }
    </div>
    <div class="footer-sitemap-group">
      <span class="footer-sitemap-heading">Services</span>
      @for (service of navServices; track service.path) {
        <a [routerLink]="service.path">{{ service.label }}</a>
      }
    </div>
    <div class="footer-sitemap-group">
      <span class="footer-sitemap-heading">Company</span>
      <a routerLink="/about">About Us</a>
      <a routerLink="/contact">Contact Us</a>
      <a routerLink="/testimonials">Testimonials</a>
      <a routerLink="/terms">Terms of Service</a>
      <a routerLink="/privacy">Privacy Policy</a>
      <a routerLink="/disclaimer">Disclaimer</a>
      <a routerLink="/refund-policy">Refund &amp; Cancellation Policy</a>
      <a routerLink="/data-deletion">Delete Your Account &amp; Data</a>
    </div>
  </nav>

  <p class="footer-disclaimer">
    <strong>Disclaimer:</strong> All calculations, outputs, and document templates provided by this website
    are for educational and informational purposes only. They do not constitute official financial, tax, or
    legal advice. Verify results with your bank, and have any document template reviewed by a qualified
    professional, before relying on it. <a routerLink="/disclaimer">Read the full disclaimer</a>.
  </p>

  <div class="footer-bottom">
    <div class="footer-legal">
      <span class="footer-copy">© {{ currentYear }} Every Rupee Spent.</span>
      <a routerLink="/about" class="footer-legal-link">About</a>
      <a routerLink="/terms" class="footer-legal-link">Terms</a>
      <a routerLink="/privacy" class="footer-legal-link">Privacy</a>
      <a routerLink="/disclaimer" class="footer-legal-link">Disclaimer</a>
      <a routerLink="/refund-policy" class="footer-legal-link">Refunds</a>
      <a routerLink="/data-deletion" class="footer-legal-link">Delete Data</a>
      <a routerLink="/contact" class="footer-legal-link">Contact</a>
      <a href="tel:+919535300245" class="footer-legal-link">Call: +91 95353 00245</a>
      <a href="https://wa.me/919535300245" target="_blank" rel="noopener" class="footer-legal-link">WhatsApp Us</a>
    </div>
    <div class="visitor-counter">
      <span class="visitor-dot"></span>
      <span class="visitor-label">Visitors</span>
      <!-- GoatCounter injects the SVG count badge here -->
      <span id="gc-visit-count"></span>
    </div>
  </div>
  <noscript><img src="https://everyrupeespent.goatcounter.com/count?p=/" alt=""/></noscript>
</footer>
